import React from 'react';
import { ShieldCheck, CheckCircle } from 'lucide-react';
import { HolographicButton } from './HolographicButton';
export function Hero() {
  const scrollToOffer = () => {
    const element = document.getElementById('offer');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-white overflow-hidden pb-12" data-id="element-68">
      {/* Super-headline Banner */}
      <div className="w-full bg-gradient-to-r from-primary-dark to-primary py-3 px-4 text-center shadow-md relative z-20" data-id="element-69">
        <p className="text-white font-bold text-sm md:text-base uppercase tracking-wide" data-id="element-70">
          ATENCIÓN MUJERES: ESTE ES EL MÉTODO PARA QUIENES YA LO INTENTARON TODO
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 md:pt-12" data-id="element-71">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-72">
          {/* Left Column: Copy */}
          <div className="order-2 md:order-1 text-center md:text-left" data-id="element-73">
            <h1 className="text-3xl md:text-5xl font-extrabold text-secondary leading-tight mb-6" data-id="element-74">
              No es falta de voluntad: <br data-id="element-75" />
              <span className="text-accent-coral" data-id="element-76">
                es tu cerebro pidiendo un rescate
              </span>
            </h1>

            <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-77">
              Descarga el eBook práctico que te guía día a día con la{' '}
              <strong data-id="element-78">Triada de 14 Días</strong> (Saturar → Silenciar →
              Estabilizar) para que el azúcar vuelva a ser una opción, no una
              necesidad.
            </p>

            {/* Bullets */}
            <ul className="space-y-3 mb-8 text-left inline-block md:block" data-id="element-79">
              {['Adiós a los antojos de las 4 pm', 'Más energía y menos inflamación sin pasar hambre', 'Hecho para comida real que consigues en Colombia'].map((item, i) => <li key={i} className="flex items-start" data-id="element-80">
                  <CheckCircle className="h-6 w-6 text-primary flex-shrink-0 mr-3" data-id="element-81" />
                  <span className="text-gray-700 font-medium" data-id="element-82">{item}</span>
                </li>)}
            </ul>

            {/* CTA */}
            <div className="flex flex-col items-center md:items-start space-y-4" data-id="element-83">
              <HolographicButton onClick={scrollToOffer} className="w-full md:w-auto shadow-xl shadow-primary/20" data-id="element-84">
                Quiero comenzar mi plan
              </HolographicButton>

              <p className="text-sm text-gray-500 font-medium" data-id="element-85">
                Pago único • Acceso de por vida • Entrega inmediata por email
              </p>

              {/* Trust Row */}
              <div className="flex items-center justify-center md:justify-start gap-4 pt-2 opacity-80" data-id="element-86">
                <div className="flex items-center gap-1 text-xs text-gray-500" data-id="element-87">
                  <ShieldCheck className="h-4 w-4" data-id="element-88" />
                  <span data-id="element-89">Pago seguro SSL</span>
                </div>
                <div className="flex gap-3 items-center" data-id="element-90">
                  <img src="https://cdn.magicpatterns.com/uploads/kghmG89Hkaibmwg1RnVYri/Visa_logo.png" alt="Visa" className="h-4 w-auto object-contain" data-id="element-91" />
                  <img src="https://cdn.magicpatterns.com/uploads/wtSaJSJvffJxG6juw3kUSJ/Mastercard_logo.png" alt="Mastercard" className="h-4 w-auto object-contain" data-id="element-92" />
                  <img src="https://cdn.magicpatterns.com/uploads/6bzYwiAPHy4Q5xVwWnqUK9/Nequi_logo.png" alt="Nequi" className="h-4 w-auto object-contain" data-id="element-93" />
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="order-1 md:order-2 flex justify-center relative" data-id="element-94">
            {/* Background blob for depth */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-accent-cream rounded-full blur-3xl -z-10" data-id="element-95"></div>

            <div className="relative" data-id="element-96">
              <img src="https://cdn.magicpatterns.com/uploads/udtq9cwkZrSVAA7wSWoAGv/mo1.webp" alt="Adiós al Azúcar eBook Mockup" className="w-full max-w-md md:max-w-full drop-shadow-2xl transform hover:scale-105 transition-transform duration-500 rounded-3xl" data-id="element-97" />

              {/* Discount Badge */}
              <div className="absolute -top-4 -right-4 bg-accent-coral text-white w-20 h-20 rounded-full flex items-center justify-center shadow-lg animate-bounce-slow z-10 border-4 border-white" data-id="element-98">
                <div className="text-center leading-tight" data-id="element-99">
                  <span className="block text-xs font-bold" data-id="element-100">AHORRA</span>
                  <span className="block text-xl font-extrabold" data-id="element-101">87%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}